import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { CEO } from "@/components/site/CEO";
import { Certifications } from "@/components/site/Certifications";
import { Services } from "@/components/site/Services";
import { Overhauling } from "@/components/site/Overhauling";
import { Training } from "@/components/site/Training";
import { Stats } from "@/components/site/Stats";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { Gallery } from "@/components/site/Gallery";

export default function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main>
        <Hero />
        <About />
        <CEO />
        <Certifications />
        <Services />
        <Overhauling />
        <Gallery />
        <Training />
        <Stats />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
